import React from 'react';
import EventBusyRoundedIcon from '@mui/icons-material/EventBusyRounded';
import StorefrontRoundedIcon from '@mui/icons-material/StorefrontRounded';
import TimelapseRoundedIcon from '@mui/icons-material/TimelapseRounded';
import TabbedPage from '../components/TabbedPage';
import MissedPunchesPage from './MissedPunchesPage';
import SiteVisitsPage from './SiteVisitsPage';
import TimesheetTab from '../components/LeaveAttendanceComps/TimesheetTab';

// The employee's own record of where they were: punches they need to correct,
// and the site visits already logged for them. One row in the sidebar, not two.
const TABS = [
    { key: 'punches', label: 'Missed Punches', icon: EventBusyRoundedIcon, render: () => <MissedPunchesPage /> },
    { key: 'history', label: 'My Attendance History', icon: TimelapseRoundedIcon, render: () => <TimesheetTab self /> },
    { key: 'visits', label: 'My Site Visits', icon: StorefrontRoundedIcon, render: () => <SiteVisitsPage self /> },
];

export default function MyActivityPage() {
    return <TabbedPage tabs={TABS} />;
}
